import { render, staticRenderFns } from "./template_1.vue?vue&type=template&id=84801812&scoped=true"
import script from "./template_1.vue?vue&type=script&lang=js"
export * from "./template_1.vue?vue&type=script&lang=js"
import style0 from "./template_1.vue?vue&type=style&index=0&id=84801812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84801812",
  null
  
)

export default component.exports